import React from 'react'

export enum LicenseHooks {
  LicenseForm = 'feature-licenses-react:license-form',
}
export type LicenseFormPayload = React.ReactElement | null
